const middleware = {}

middleware['_core/anonymous'] = require('../middleware/_core/anonymous.js')
middleware['_core/anonymous'] = middleware['_core/anonymous'].default || middleware['_core/anonymous']

middleware['_core/authenticated'] = require('../middleware/_core/authenticated.js')
middleware['_core/authenticated'] = middleware['_core/authenticated'].default || middleware['_core/authenticated']

middleware['_core/layout'] = require('../middleware/_core/layout.js')
middleware['_core/layout'] = middleware['_core/layout'].default || middleware['_core/layout']

middleware['_core/oauth'] = require('../middleware/_core/oauth.js')
middleware['_core/oauth'] = middleware['_core/oauth'].default || middleware['_core/oauth']

middleware['_core/querystring'] = require('../middleware/_core/querystring.js')
middleware['_core/querystring'] = middleware['_core/querystring'].default || middleware['_core/querystring']

middleware['_core/saml'] = require('../middleware/_core/saml.js')
middleware['_core/saml'] = middleware['_core/saml'].default || middleware['_core/saml']

middleware['topicTypes'] = require('../middleware/topicTypes.js')
middleware['topicTypes'] = middleware['topicTypes'].default || middleware['topicTypes']

export default middleware
